import { useMemo } from 'react';

import { useSubscriptions } from '@adsk/alloy-provider';

const useProductsAccessTypes = ({ cleanLicenses, cleanLicensesLoading }) => {
  const { data: userSubscriptionsData, loading: userSubscriptionsLoading } =
    useSubscriptions(cleanLicenses);

  const result = useMemo(() => {
    if (!cleanLicenses) return undefined;

    return userSubscriptionsData?.reduce(
      (productsAccessTypes, subscription) => {
        if (subscription.status === 'active') {
          subscription.products.forEach((product) => {
            const index = productsAccessTypes.findIndex(
              (item) => item.productType === product.productKey
            );

            if (index === -1) {
              productsAccessTypes.push({
                productType: product.productKey,
                type: subscription.type,
              });
            } else {
              const accessType = productsAccessTypes[index].type;

              if (accessType !== 'paid' && subscription.type === 'paid') {
                productsAccessTypes[index].type = subscription.type;
              }
            }
          });
        }
        return productsAccessTypes;
      },
      []
    );
  }, [cleanLicenses, userSubscriptionsData]);

  return {
    loading:
      cleanLicensesLoading || (cleanLicenses && userSubscriptionsLoading),
    data: result,
  };
};

export { useProductsAccessTypes };
